<template>
  <v-card
    class="d-flex-row justify-space-around align-center ma-0 py-2 px-4"
    elevation="0"
  >
    <div style="width: 100%">
      <v-card-title class="card-title pl-0">
        <v-icon v-if="arrow" class="pr-2" @click="voltar" color="#BC0000">mdi-arrow-left</v-icon>
        <b :style="!arrow ? 'margin-left: 15px' : ''"> {{ title }}</b>
      </v-card-title>
      <v-card-text class="card-text">{{ text }} </v-card-text>
    </div>

    <div class="d-flex my-0 py-2 px-12" style="justify-content: flex-end">
      <v-btn class="primary-button hidden-sm-and-down" v-if="haveAction" @click="action1">
        Cadastrar aplicador
      </v-btn>

      <v-btn
        tile
        fab
        class="primary-button hidden-md-and-up"
        v-if="haveAction"
        @click="action1"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-btn
        class="secondary-button hidden-sm-and-down"
        v-if="haveAction"
        @click="action2"
      >
        Importar aplicadores
      </v-btn>

      <v-btn
        fab
        tile
        class="secondary-button hidden-md-and-up"
        v-if="haveAction"
        @click="action2"
      >
        <v-icon>mdi-cloud-upload</v-icon>
      </v-btn>

      <v-btn
        fab
        outlined
        tile
        class="terciary-button hidden-md-and-up"
        v-if="haveAction"
        @click="action3"
      >
        <v-icon>mdi-download-outline</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.card-title {
  font-family: Roboto;
  font-size: 1.5rem !important;
}

.card-text {
  display: flex;
  justify-content: space-between;

  font-family: Roboto;
  font-size: 1rem;
  font-weight: 300;
  line-height: 30px;

  width: 80%;

  color: #9c9c9c;
}

@media (max-width: 500px) {
  .card-title {
    font-family: Roboto;
    font-size: 1.3rem !important;
    padding: 0;
  }

  .card-text {
    font-size: 0.9rem !important;
    width: 80%;
  }
}
@media (max-width: 900px) {
  .card-title {
    font-family: Roboto;
    font-size: 1.7rem;
    padding: 0;
  }

  .card-text {
    font-size: 0.9rem;
    width: 80%;
  }
}
</style>

<script>
export default {
  name: "HeaderCard",

  props: {
    arrow: Boolean,
    title: String,
    text: String,
    actionTitle: String,
    haveAction: Boolean,
  },

  methods: {
    action1() {
      this.$emit("action1");
    },

    action2() {
      this.$emit("action2");
    },

    action3() {
      this.$emit("action3");
    },

    voltar() {
      this.$emit("voltar");
    },
  },
};
</script>
